import { __assign, __awaiter, __generator } from "tslib";
import { Utils, utils } from '../utils/workerUtils';
import directFullscreenHelper from '../helpers/directFullscreenHelper';
import BiLogger from '../utils/BiLogger';
import * as VideoGallerySDK from '@wix/video-gallery-sdk';
// import loadItemDimensions from './helpers/itemDimensionsLoader';
import { AppSettings, experimentsWrapper, resizeMediaUrl, Consts, getProGalleryStyles, parseStyleParams, } from '@wix/photography-client-lib';
import { serverItemsToProGallery } from '@wix/pro-gallery-items-formatter';
import { GalleryItem, GALLERY_CONSTS, BlueprintsManager, blueprints, } from 'pro-gallery-lib';
import BlueprintsApi from './WorkerBlueprintsApi';
import { reactionServiceManager } from '../store/reactionServiceManager';
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.reject = reject;
            _this.resolve = resolve;
        });
    }
    return Deferred;
}());
var UNKNOWN_CONTAINER = {
    desktop: {
        isDefaultWidth: true,
        isDefaultHeight: true,
        isPrerenderContainer: true,
        avoidGallerySelfMeasure: true,
        width: 1920,
        height: 1080,
        screen: { width: 1920, height: 1080 },
        mobilePreviewFrame: { width: 1920, height: 1080 },
    },
    mobile: {
        isDefaultWidth: true,
        isDefaultHeight: true,
        isPrerenderContainer: true,
        avoidGallerySelfMeasure: true,
        width: 320,
        height: 640,
        screen: { width: 320, height: 640 },
        mobilePreviewFrame: { width: 320, height: 640 },
    },
};
var ProGalleryStore = /** @class */ (function () {
    function ProGalleryStore(context, wixCodeApi, platformServices, scopedGlobalSdkApis, APP_DEFINITION_ID, GALLERY_WIDGET_ID, isArtStore, setDirectfullscreenItemCallBack, setBlueprintCallback, avoidGettingItemsFromPGServer, setItemsLoveDataCallback, sentryReport) {
        var _this = this;
        this.createFedopsLogger = function (platformServices) {
            var fedOpsLoggerFactory = platformServices.fedOpsLoggerFactory;
            _this.fedopsLogger = fedOpsLoggerFactory.getLoggerForWidget({
                appId: _this.APP_DEFINITION_ID,
                widgetId: _this.GALLERY_WIDGET_ID,
            });
        };
        this.tryToReportAppLoaded = function (isSSR) {
            if (isSSR === void 0) { isSSR = false; }
            if (_this.isAppLoadStartReported && !_this.isAppLoadedReported) {
                try {
                    if (isSSR) {
                        _this.fedopsLogger.appLoaded();
                    }
                    else {
                        _this.fedopsLogger.appLoaded(_this.getFedopsCustomParams());
                    }
                    _this.isAppLoadedReported = true;
                }
                catch (e) {
                    if (utils.isVerbose()) {
                        console.log('cant run fedopsLogger.appLoaded()', e);
                    }
                }
            }
        };
        this.initFlowPromises();
        this.context = context;
        this.setItemsCurrentId = 0;
        this.setStyles(context.styles);
        this.wixCodeApi = wixCodeApi;
        this.directfullscreenItem = 'init';
        this.SSRWorkerLog = ['constructor'];
        this.APP_DEFINITION_ID = APP_DEFINITION_ID;
        this.GALLERY_WIDGET_ID = GALLERY_WIDGET_ID;
        this.isArtStore = isArtStore;
        this.avoidGettingItemsFromPGServer = avoidGettingItemsFromPGServer;
        this.isAccessible = false;
        this.reportBiLog = this.reportBiLog.bind(this);
        this.getGalleryDataFromServer = this.getGalleryDataFromServer.bind(this);
        this.setSettings = this.setSettings.bind(this);
        this.getMoreItemsFromServer = this.getMoreItemsFromServer.bind(this);
        this.getMoreWixCodeItems = this.getMoreWixCodeItems.bind(this);
        this.loadInitialWixCodeItems = this.loadInitialWixCodeItems.bind(this);
        this.getItemsFromWixCode = this.getItemsFromWixCode.bind(this);
        this.setBlueprintIfNeeded = this.setBlueprintIfNeeded.bind(this);
        this.loadDirectFullscreenFromWixCode = this.loadDirectFullscreenFromWixCode.bind(this);
        this.prepareAndSetItems = this.prepareAndSetItems.bind(this);
        this.prepareItems = this.prepareItems.bind(this);
        this.getItems = this.getItems.bind(this);
        this.setPageName = this.setPageName.bind(this);
        this.formatServerGalleryResponse = this.formatServerGalleryResponse.bind(this);
        this.itemDimensionsCache = {};
        this.viewMode = Utils.parseViewMode(this.wixCodeApi.window.viewMode);
        this.formFactor = Utils.parseFormFactor(this.wixCodeApi.window.formFactor);
        this.isMobile = utils.isMobile(this.formFactor);
        this.initPrerenderContainer();
        this.baseUrl = Utils.getBaseUrl(this.wixCodeApi, this.viewMode);
        this.SSRWorkerLog.push('baseUrl: ' + this.baseUrl);
        this.appSettingsBaseUrl =
            this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW ||
                this.viewMode === GALLERY_CONSTS.viewMode.EDIT
                ? ''
                : this.baseUrl; // to debug locally, for PREVIEW sometimes need to put 'https://editor.wix.com',
        this.SSRWorkerLog.push('appSettingsBaseUrl: ' + this.appSettingsBaseUrl);
        this.appSettings = new AppSettings(this.context.compId, this.context.instance, this.viewMode, this.appSettingsBaseUrl);
        if (this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW ||
            this.viewMode === GALLERY_CONSTS.viewMode.EDIT) {
            // encode instance only when needed (in preview or editor only), too have for live site.
            var encodedInstance = this.context.instance.substring(this.context.instance.indexOf('.') + 1);
            var isDemoMode = JSON.parse(atob(encodedInstance)).demoMode;
            this.dataSavedState = isDemoMode
                ? Consts.dataSavedState.PUBLISHED
                : Consts.dataSavedState.SAVED;
        }
        else {
            this.dataSavedState = Consts.dataSavedState.PUBLISHED;
        }
        this.scopedGlobalSdkApis = scopedGlobalSdkApis;
        this.pgRenderStart = Date.now();
        this.setBlueprintCallback = setBlueprintCallback;
        this.setItemsLoveDataCallback = setItemsLoveDataCallback;
        this.sentryReport = sentryReport;
        this.setDirectfullscreenItemCallBack = setDirectfullscreenItemCallBack;
        this.setDirectfullscreenOnce = false;
        this.ITEMS_BATCH_SIZE = 50;
        this.INITIAL_ITEMS_BATCH_SIZE = 50;
        this.shouldUseBlueprintsFromServer = false;
        try {
            this.createFedopsLogger(platformServices);
            this.fedopsLogger.appLoadStarted();
            this.isAppLoadStartReported = true;
        }
        catch (e) {
            console.error('Cannot create fedops logger', e);
            this.fedopsLogger = {
                appLoaded: function () { },
                appLoadStarted: function () { },
            };
            this.isAppLoadStartReported = true;
        }
        this.biLogger = new BiLogger(platformServices.biLoggerFactory(), this.viewMode, this.isArtStore);
        this.fullListOfItemsLoveData = [];
    }
    ProGalleryStore.prototype.initPrerenderContainer = function () {
        this.predefinedDimensions = this.context.dimensions
            ? // We have dimensions only in Thunderbolt. in bolt they wont be here and will arrive oly in the client
                Utils.onlyNumericValues(this.context.dimensions) // We take into account only numeric values. if we have an empty string (responsive) it will be calculated in the client for the following blueprint.
            : {};
        if (this.viewMode !== GALLERY_CONSTS.viewMode.EDIT) {
            // there should be no inputs from our side in the editor. no prerender.
            this.prerenderContainer = __assign(__assign(__assign({}, UNKNOWN_CONTAINER[this.isMobile ? 'mobile' : 'desktop']), (this.predefinedDimensions.width && {
                width: this.predefinedDimensions.width,
                isDefaultWidth: false,
            })), (this.predefinedDimensions.height && {
                height: this.predefinedDimensions.height,
                isDefaultHeight: false,
            }));
            this.setDimensions(this.prerenderContainer);
        }
    };
    ProGalleryStore.prototype.initDataSavedState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var encodedInstance, isDemoMode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Utils.verifyExperiments(this.scopedGlobalSdkApis)];
                    case 1:
                        _a.sent(); // make sure experiments were requested and are ready before proceeding
                        if (experimentsWrapper.getExperimentBoolean('specs.pro-gallery.templates-api-editor-and-preview')) {
                            this.dataSavedState = Consts.dataSavedState.PUBLISHED;
                            if (this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW ||
                                this.viewMode === GALLERY_CONSTS.viewMode.EDIT) {
                                encodedInstance = this.context.instance.substring(this.context.instance.indexOf('.') + 1);
                                isDemoMode = JSON.parse(atob(encodedInstance)).demoMode;
                                this.dataSavedState = isDemoMode
                                    ? Consts.dataSavedState.PUBLISHED
                                    : Consts.dataSavedState.SAVED;
                            }
                        }
                        else {
                            this.dataSavedState =
                                this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW ||
                                    this.viewMode === GALLERY_CONSTS.viewMode.EDIT
                                    ? Consts.dataSavedState.SAVED
                                    : Consts.dataSavedState.PUBLISHED;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.isSSR = function () {
        return this.wixCodeApi.window.rendering.env === 'backend';
    };
    ProGalleryStore.prototype.getFedopsCustomParams = function () {
        var customParams = {
            customParams: JSON.stringify({
                gallery_id: this.galleryId || 'galleryId is undefined',
            }),
        };
        return customParams;
    };
    ProGalleryStore.prototype.setSettings = function (settings) {
        var parseSettings = function (_settings) {
            if (typeof _settings === 'string') {
                try {
                    return JSON.parse(_settings);
                }
                catch (e) {
                    console.error('Failed parse settting', e);
                    return _settings;
                }
            }
            return _settings;
        };
        var prevSettings = parseSettings(this.settings);
        var nextSettings = parseSettings(settings);
        this.settings = __assign(__assign({}, prevSettings), nextSettings);
    };
    ProGalleryStore.getSiteUrl = function (api) {
        return api.location.baseUrl;
    };
    ProGalleryStore.getPageUrl = function (api) {
        var url = api.location.url.split('?')[0];
        return url;
    };
    ProGalleryStore.prototype.reportBiLog = function (funcName, data) {
        this.biLogger.log(this.galleryId, funcName, data);
    };
    ProGalleryStore.prototype.createShareUrl = function (itemId, api) {
        if (this.isArtStore)
            return null; // remove when art-store is using the new share methods
        var pageUrl = ProGalleryStore.getPageUrl(api);
        return (pageUrl +
            '?pgid=' +
            this.context.compId.replace('comp-', '') +
            '-' +
            itemId);
    };
    ProGalleryStore.getCurrentDirectFullscreenUrl = function (api) {
        var pageUrl = ProGalleryStore.getPageUrl(api);
        var query = api.location.query;
        var pgid = query && query.pgid;
        if (pgid) {
            return pageUrl + '?pgid=' + pgid;
        }
        else {
            return null;
        }
    };
    ProGalleryStore.getTranslations = function (locale) {
        if (locale === void 0) { locale = 'en'; }
        // only under scope `pro-gallery-viewer`
        return fetch("https://static.parastorage.com/services/pro-gallery-statics/2.2007.0/assets/locale/pro-gallery/Gallery/Gallery_" + locale + ".json")
            .then(function (res) { return res.json(); })
            .catch(function () {
            return {};
        });
    };
    ProGalleryStore.prototype.getAppSettings = function (isSSR) {
        return __awaiter(this, void 0, void 0, function () {
            var appSettings, compId, biData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.appSettings.get(this.dataSavedState)];
                    case 1:
                        appSettings = _a.sent();
                        if (appSettings && appSettings.galleryId) {
                            Object.assign(this, __assign({}, appSettings));
                            this.appSettingsData = appSettings;
                            return [2 /*return*/, appSettings];
                        }
                        else {
                            if (!isSSR && !this.isArtStore) {
                                compId = this.context.compId;
                                biData = {
                                    compId: compId,
                                    errorType: 'no_appSettings.galleryId',
                                };
                                this.reportBiLog('proGalleryErrorUou', biData);
                            }
                            return [2 /*return*/, undefined];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to get settings: ' + error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.getGallerySettings = function (isSSR) {
        if (isSSR === void 0) { isSSR = false; }
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getGalleryDataFromServer({ from: 0, options: { isSSR: isSSR } }).then(function (response) {
                                if (response && response.galleryId) {
                                    var galleryId = response.galleryId, dateCreated = response.dateCreated;
                                    var settings = response.pageResponse.settings;
                                    _this.galleryId = galleryId;
                                    _this.dateCreated = dateCreated;
                                    _this.setSettings(settings);
                                    return { galleryId: galleryId, dateCreated: dateCreated, settings: _this.settings };
                                }
                                else {
                                    return undefined;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Failed to get gallery settings: ' + error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.formatServerGalleryResponse = function (serverGalleryResponseData, settings) {
        var gallery = serverGalleryResponseData && serverGalleryResponseData.gallery;
        return !!gallery
            ? {
                dateCreated: gallery.created,
                galleryId: gallery.id,
                pageResponse: {
                    totalItemsCount: gallery.totalItemsCount,
                    settings: JSON.stringify(settings),
                    items: this.setPageName(serverItemsToProGallery(gallery.items)),
                },
            }
            : {};
    };
    ProGalleryStore.prototype.setPageName = function (proGalleryItems) {
        var sitePages = this.wixCodeApi.site.getSiteStructure({
            includePageId: true,
        }).pages;
        return proGalleryItems.map(function (item) {
            try {
                if ('metaData' in item &&
                    'link' in item.metaData &&
                    'data' in item.metaData.link &&
                    'type' in item.metaData.link.data &&
                    item.metaData.link.data.type === 'PageLink') {
                    var page_1 = sitePages.find(function (_page) {
                        return item.metaData.link.data.pageId.endsWith(_page.id);
                    });
                    if (!!page_1 && 'name' in page_1) {
                        item.metaData.link.data.pageName = page_1.name;
                    }
                }
            }
            catch (error) { }
            return item;
        });
    };
    ProGalleryStore.prototype.getMultiLangFields = function () {
        var currentShortLang = this.wixCodeApi.window.multilingual
            .currentLanguage;
        var currentLang = this.wixCodeApi.window.multilingual.siteLanguages.filter(function (lang) { return lang.languageCode === currentShortLang; });
        if (currentLang.length > 0) {
            return {
                isPrimaryLanguage: currentLang[0].isPrimaryLanguage,
                lang: currentShortLang,
                locale: currentLang[0].locale,
            };
        }
        return null;
    };
    ProGalleryStore.prototype.getMultiLangHeader = function () {
        var fields = this.getMultiLangFields();
        var instanceId = this.context.instanceId;
        var header = fields
            ? fields.lang + "|" + fields.locale + "|" + fields.isPrimaryLanguage.toString() + "|" + instanceId
            : '';
        this.SSRWorkerLog.push('Multilingual header: ' + header);
        return header;
    };
    ProGalleryStore.prototype.getLangQuery = function () {
        var fields = this.getMultiLangFields();
        var query = fields ? "" + fields.lang + fields.locale : '';
        return query;
    };
    ProGalleryStore.prototype.getGalleryDataFromServer = function (_a) {
        var from = _a.from, _b = _a.batchSize, batchSize = _b === void 0 ? this.ITEMS_BATCH_SIZE : _b, _c = _a.options, options = _c === void 0 ? {} : _c, _d = _a.settings, settings = _d === void 0 ? null : _d;
        return __awaiter(this, void 0, void 0, function () {
            var _e, isSSR, to, _f, compId, instanceId, instance, externalId, _g, _h, limit, itemsUrl, response, data, error_3, blockOldAPIsInPreview, blockOldAPIsInViewer, blockOldAPI, itemsUrl;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _e = options.isSSR, isSSR = _e === void 0 ? false : _e;
                        this.SSRWorkerLog.push('Getting data from server, isSSR: ' + isSSR);
                        to = from + batchSize;
                        _f = this.context, compId = _f.compId, instanceId = _f.instanceId, instance = _f.instance;
                        externalId = this.context.externalId;
                        if (!externalId) {
                            // externalId of a new site before publish in Preview is "", so we protect here undefined and ""
                            externalId = '00000000-0000-0000-0000-000000000000';
                        }
                        return [4 /*yield*/, Utils.verifyExperiments(this.scopedGlobalSdkApis)];
                    case 1:
                        _j.sent(); // make sure experiments were requestd and are ready before proceeding
                        if (!!this.isArtStore) return [3 /*break*/, 10];
                        this.SSRWorkerLog.push('trying to get settings');
                        if (!settings) return [3 /*break*/, 2];
                        _g = settings;
                        return [3 /*break*/, 5];
                    case 2:
                        _h = this.appSettingsData;
                        if (_h) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getAppSettings(isSSR)];
                    case 3:
                        _h = (_j.sent());
                        _j.label = 4;
                    case 4:
                        _g = _h;
                        _j.label = 5;
                    case 5:
                        settings = _g;
                        this.SSRWorkerLog.push('settings are: ' +
                            settings +
                            ' appsettingsData: ' +
                            this.appSettingsData);
                        limit = to - from;
                        itemsUrl = this.galleryId &&
                            this.baseUrl + "/pro-gallery-webapp/v1/galleries/" + this.galleryId + "?offset=" + from + "&limit=" + limit + "&externalId=" + externalId + "&state=" + this.dataSavedState + "&lang=" + this.getLangQuery();
                        if (!itemsUrl) return [3 /*break*/, 10];
                        _j.label = 6;
                    case 6:
                        _j.trys.push([6, 9, , 10]);
                        this.SSRWorkerLog.push('Trying to fetch from new server with url: ' + itemsUrl);
                        return [4 /*yield*/, fetch(itemsUrl, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: instance,
                                    'x-wix-linguist': this.getMultiLangHeader(),
                                },
                            })];
                    case 7:
                        response = _j.sent();
                        return [4 /*yield*/, response.json()];
                    case 8:
                        data = _j.sent();
                        this.SSRWorkerLog.push('Got items from new server');
                        return [2 /*return*/, this.formatServerGalleryResponse(data, settings)];
                    case 9:
                        error_3 = _j.sent();
                        console.error('Failed to get data from (new) server: ', error_3);
                        this.SSRWorkerLog.push('Failed to get items from new server : ' + error_3);
                        return [3 /*break*/, 10];
                    case 10:
                        blockOldAPIsInPreview = this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW;
                        blockOldAPIsInViewer = this.viewMode !== GALLERY_CONSTS.viewMode.PREVIEW &&
                            experimentsWrapper.getExperimentBoolean('specs.pro-gallery.blockOldServerItemsFallback');
                        blockOldAPI = blockOldAPIsInViewer || blockOldAPIsInPreview;
                        if (!this.isArtStore && blockOldAPI) {
                            if (utils.isVerbose()) {
                                console.log('fallback to old server was blocked');
                            }
                            this.SSRWorkerLog.push('Fallback to old server was blocked, isSSR: ' + isSSR);
                            return [2 /*return*/, Promise.resolve([])];
                        }
                        else {
                            itemsUrl = this.addSsrUrlParams(isSSR, this.baseUrl + "/_api/pro-gallery-webapp/v1/gallery/" + instanceId + "/items/from/" + from + "/to/" + to + "?compId=" + compId + "&externalId=" + externalId);
                            if (utils.isVerbose()) {
                                console.log('Getting items from server', from, to, itemsUrl);
                            }
                            this.SSRWorkerLog.push('trying to get items from the old server ');
                            return [2 /*return*/, fetch(itemsUrl, {
                                    headers: {
                                        'x-wix-linguist': this.getMultiLangHeader(),
                                    },
                                })
                                    .then(function (res) {
                                    if (res.status === 200) {
                                        _this.SSRWorkerLog.push('Got items from old server');
                                        return res.json();
                                    }
                                    else if (res.status === 404 && isSSR) {
                                        if (utils.isVerbose()) {
                                            console.log('first publish');
                                        }
                                        return [];
                                    }
                                    else {
                                        throw new Error(res.statusText);
                                    }
                                })
                                    .catch(function (e) {
                                    _this.SSRWorkerLog.push('Failed to get items from old server : ' + e);
                                    console.error('Could not get items from (old) server', e);
                                    return [];
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.getConnectedProvidersFromServer = function (wixInstance) {
        if (wixInstance === void 0) { wixInstance = false; }
        var baseUrl = Utils.getBaseUrl(this.wixCodeApi, this.viewMode);
        var instance = this.context.instance;
        if (wixInstance) {
            instance = wixInstance;
        }
        var url = baseUrl + "/_api/pro-gallery-webapp/v1/store/providers?instance=" + instance;
        return fetch(url).then(function (response) {
            return response.json();
        });
    };
    ProGalleryStore.prototype.getQueryParams = function () {
        return this.wixCodeApi.location.query;
    };
    ProGalleryStore.isValidUUID = function (itemId) {
        var regEx = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return !!itemId.match(regEx);
    };
    ProGalleryStore.prototype.getItemByIdFromOldServer = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, _a, instanceId, externalId, compId, _externalId, itemsUrl;
            return __generator(this, function (_b) {
                if (!ProGalleryStore.isValidUUID(itemId)) {
                    return [2 /*return*/, {
                            item: 'itemId: ' + itemId + 'is not valid',
                        }];
                }
                baseUrl = Utils.getBaseUrl(this.wixCodeApi, this.viewMode);
                _a = this.context, instanceId = _a.instanceId, externalId = _a.externalId, compId = _a.compId;
                _externalId = externalId;
                if (!_externalId) {
                    _externalId = '00000000-0000-0000-0000-000000000000';
                }
                itemsUrl = baseUrl + "/_api/pro-gallery-webapp/v1/gallery/components/" + compId + "/items/" + itemId + "?instanceId=" + instanceId + "&externalId=" + _externalId;
                return [2 /*return*/, fetch(itemsUrl)
                        .then(function (res) {
                        if (res.status === 200) {
                            return res.json();
                        }
                        else {
                            return {
                                item: 'server response was not 200' +
                                    itemsUrl +
                                    'the response Status:' +
                                    res.status,
                            };
                        }
                    })
                        .catch(function (e) {
                        console.error('Could not get item by id from the server', e);
                        return {
                            item: 'some error when requesting from server' + itemsUrl + e.message,
                        };
                    })];
            });
        });
    };
    ProGalleryStore.prototype.getItemByIdFromNewServer = function (itemId, isSSR) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, instance, galleryId, settings, itemsUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ProGalleryStore.isValidUUID(itemId)) {
                            return [2 /*return*/, {
                                    item: 'itemId: ' + itemId + 'is not valid',
                                }];
                        }
                        baseUrl = Utils.getBaseUrl(this.wixCodeApi, this.viewMode);
                        instance = this.context.instance;
                        if (!!this.galleryId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getAppSettings(isSSR)];
                    case 1:
                        settings = _a.sent();
                        galleryId = settings && settings.galleryId;
                        if (!!settings) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getGallerySettings(isSSR)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        galleryId = this.galleryId;
                        itemsUrl = baseUrl + "/pro-gallery-webapp/v1/galleries/" + galleryId + "/items/" + itemId + "?state=" + this.dataSavedState;
                        return [2 /*return*/, fetch(itemsUrl, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: instance,
                                    'x-wix-linguist': this.getMultiLangHeader(),
                                },
                            })
                                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                var response, item, formattedItem;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(res.status === 200)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, res.json()];
                                        case 1:
                                            response = _a.sent();
                                            item = response.item;
                                            if (item && item.id) {
                                                formattedItem = serverItemsToProGallery([item]);
                                                return [2 /*return*/, formattedItem[0]];
                                            }
                                            return [2 /*return*/, item];
                                        case 2: return [2 /*return*/, {
                                                item: 'server response was not 200' +
                                                    itemsUrl +
                                                    'the response Status:' +
                                                    res.status,
                                            }];
                                    }
                                });
                            }); })
                                .catch(function (e) {
                                console.error('Could not get item by id from the server', e);
                                return {
                                    item: 'some error when requesting from server' + itemsUrl + e.message,
                                };
                            })];
                }
            });
        });
    };
    ProGalleryStore.prototype.getMoreItemsFromServer = function (from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getGalleryDataFromServer({ from: from }).then(function (res) {
                        return res.pageResponse.items;
                    })];
            });
        });
    };
    ProGalleryStore.prototype.addSsrUrlParams = function (isSSR, itemsUrl) {
        if (isSSR) {
            itemsUrl += '&petri_ovr=specs.SkipCachePopulationSpec:true';
        }
        return itemsUrl;
    };
    ProGalleryStore.prototype.navigateToLink = function (itemData) {
        var link = itemData &&
            itemData.dto &&
            itemData.dto.metaData &&
            itemData.dto.metaData.link; // replace to when available - itemData?.dto?.metaData?.link;
        try {
            if (link) {
                if (link.type === 'web') {
                    this.wixCodeApi.location.to(link.url);
                }
                else if (link.type === 'page') {
                    try {
                        var pageUrl = this.wixCodeApi.site
                            .getSiteStructure({ includePageId: true })
                            .pages.find(function (page) { return page.id === link.url; }).url;
                        this.wixCodeApi.location.to(pageUrl);
                    }
                    catch (e) {
                        console.warn('Cannot navigate to page', e);
                    }
                }
                else if (link.type === 'wix') {
                    var linkData = link.data;
                    if (linkData) {
                        var externalUrl = this.wixCodeApi.location.getExternalUrl(linkData);
                        if (!externalUrl) {
                            this.wixCodeApi.location.navigateTo(linkData);
                        }
                        else {
                            console.error('this should have been handled by <a href>');
                        }
                    }
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    ProGalleryStore.prototype.getVideoMediaId = function (item) {
        if (item.metaData.videoUrl &&
            item.metaData.videoUrl.includes('wix:video://')) {
            return item.metaData.videoUrl.split('/')[3] || item.itemId;
        }
        else {
            return item.mediaUrl;
        }
    };
    ProGalleryStore.prototype.getItemWithVideoUrls = function (item) {
        var videoId = this.getVideoMediaId(item);
        return VideoGallerySDK.getVideoURLs(videoId)
            .then(function (qualities) {
            item.metaData.qualities = qualities
                .filter(function (quality) { return quality.type === 'MP4'; })
                .map(function (qualityObject) {
                var url = qualityObject.url;
                var quality = qualityObject.quality;
                var height = parseInt(quality);
                var width = Math.floor((height * item.metaData.width) / item.metaData.height);
                return {
                    url: url,
                    height: height,
                    width: width,
                    quality: quality,
                    formats: ['mp4'],
                };
            });
            item.metaData.videoUrl = undefined;
            if (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.excludeFromHlsVideos')) {
                var hls = qualities.filter(function (quality) { return quality.type === 'HLS'; });
                if (hls.length > 0) {
                    item.metaData.videoUrl = hls[0].url;
                }
            }
            else {
                item.metaData.ghostItem = true; // see below. this is here just for the experiment to have an "else" and not stay placeholder.
            }
            return item;
        })
            .catch(function (e) {
            item.metaData.ghostItem = true; // item does not exist but is still in the pg database
            return item;
        });
    };
    ProGalleryStore.prototype.getItemsWithWixVideosUrls = function (items) {
        var _this = this;
        var result = items.map(function (item) {
            if (_this.isUnreadyVideoFile(item)) {
                return _this.getItemWithVideoUrls(item);
            }
            else {
                return Promise.resolve(item);
            }
        });
        return Promise.all(result);
    };
    ProGalleryStore.prototype.replaceByPlaceHolder = function (item) {
        return {
            itemId: item.itemId,
            mediaUrl: item.metaData.posters[0].url,
            orderIndex: 0,
            metaData: __assign(__assign({}, item.metaData), { type: 'image', isVideoPlaceholder: true, height: item.metaData.posters[0].height, width: item.metaData.posters[0].width }),
        };
    };
    ProGalleryStore.prototype.isUnreadyVideoFile = function (item) {
        return (!item.metaData.ghostItem &&
            ((item.metaData.videoUrl &&
                item.metaData.videoUrl.includes('wix:video://')) ||
                (item.metaData.type === 'video' &&
                    item.mediaUrl &&
                    !item.metaData.videoUrl)));
    };
    ProGalleryStore.prototype.addItemProperties = function (item) {
        var convertedToPlaceholder = false;
        if (this.isUnreadyVideoFile(item)) {
            item = this.replaceByPlaceHolder(item);
            convertedToPlaceholder = true;
        }
        var directLink = {
            url: undefined,
            target: undefined,
        };
        if (item.metaData && item.metaData.link) {
            var link = item.metaData.link;
            if (link.type === 'web' && typeof link.url === 'string') {
                var isExternal = link.url.slice(0, 4) === 'http' || link.url.slice(0, 2) === '//';
                if (isExternal || this.wixCodeApi.seo.isInSEO()) {
                    // bots need to see inner pathing e.g. "/subpage", they can only see it if its on the <a> tag JIRA PG-193
                    directLink = {
                        url: link.url,
                        target: '_blank',
                    };
                }
            }
            else if (link.type === 'wix') {
                var linkData_1 = link.data;
                if (linkData_1) {
                    try {
                        var externalUrl = this.wixCodeApi.location.getExternalUrl(linkData_1);
                        if (externalUrl) {
                            directLink = {
                                url: externalUrl,
                                target: '_blank',
                            };
                        }
                        else if (!!linkData_1.pageName &&
                            linkData_1.target === '_blank' &&
                            linkData_1.type === 'PageLink') {
                            var pageUrl = this.wixCodeApi.site
                                .getSiteStructure({ includePageId: true })
                                .pages.find(function (page) { return page.name === linkData_1.pageName; });
                            var url = pageUrl &&
                                pageUrl.url &&
                                this.wixCodeApi.location.baseUrl &&
                                this.wixCodeApi.location.baseUrl + pageUrl.url;
                            directLink = !!url
                                ? {
                                    url: url,
                                    target: '_blank',
                                }
                                : directLink;
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }
        }
        item.directLink = directLink;
        var itemId = function () {
            return item.id || item.photoId || item.itemId;
        };
        item.directShareLink = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.itemDeeplinks')
            ? this.createShareUrl(itemId(), this.wixCodeApi)
            : null;
        return { item: item, convertedToPlaceholder: convertedToPlaceholder };
    };
    ProGalleryStore.prototype.prepareItems = function (items) {
        var _this = this;
        // TODO - make item properties be added only once - this is getting bigger.
        var shouldGetVideoUrls = false;
        var itemsListToGetLoveData = []; // Items that haven't yet got their love data
        var shouldUseReactionService = reactionServiceManager.shouldUseReactionService();
        var itemsToSet;
        if (items && items.length >= 0) {
            itemsToSet = items.map(function (item) {
                var _a = _this.addItemProperties(item), resItem = _a.item, convertedToPlaceholder = _a.convertedToPlaceholder;
                if (!shouldGetVideoUrls && convertedToPlaceholder) {
                    shouldGetVideoUrls = true;
                }
                if (utils.isDimensionless(resItem)) {
                    var itemWithDimensions = _this.addDimensionsFromCache(resItem);
                    if (!!itemWithDimensions) {
                        resItem = itemWithDimensions;
                    }
                }
                if (typeof resItem.metaData === 'string') {
                    // TODO - check this.... this moved from the itemsHelper.
                    try {
                        resItem = __assign(__assign({}, resItem), { metaData: JSON.parse(resItem.metaData) });
                    }
                    catch (e) {
                        console.error('Failed parse item metaData', e);
                    }
                }
                // Item Love Data
                if (!resItem.isVisitedLoveData && shouldUseReactionService) {
                    itemsListToGetLoveData.push({ itemId: item.itemId });
                    resItem.isVisitedLoveData = true;
                }
                return resItem;
            });
        }
        else {
            console.error('corrupt items', items, 'returning old items instead');
            itemsToSet = this.items;
        }
        this.getItemsLoveDataIfNeeded(itemsListToGetLoveData);
        return { itemsToSet: itemsToSet, shouldGetVideoUrls: shouldGetVideoUrls };
    };
    ProGalleryStore.prototype.getItemsFromWixCode = function (_a) {
        var from = _a.from, _b = _a.batchSize, batchSize = _b === void 0 ? this.ITEMS_BATCH_SIZE : _b;
        return this.allWixCodeItems.slice(from, from + batchSize);
    };
    ProGalleryStore.prototype.loadInitialWixCodeItems = function () {
        var newItems = this.getItemsFromWixCode({
            from: 0,
            batchSize: this.INITIAL_ITEMS_BATCH_SIZE,
        });
        this.prepareAndSetItems({ newItems: newItems });
        this.loadDirectFullscreenFromWixCode();
    };
    ProGalleryStore.prototype.loadDirectFullscreenFromWixCode = function () {
        var directFullscreenItem = directFullscreenHelper.getDirectFullscreenItemFromItemsList(this.wixCodeApi.location.query, this.allWixCodeItems, this.context.compId);
        directFullscreenItem && this.setDirectFullscreenItem(directFullscreenItem);
    };
    ProGalleryStore.prototype.prepareAndSetItems = function (_a) {
        var newItems = _a.newItems, setItemsId = _a.setItemsId, _b = _a.currentItems, currentItems = _b === void 0 ? [] : _b;
        // Here we have a system to prevent returning async item calls (like getting videoUrls) from applying over newer calls form itemsToSet:.
        if (setItemsId && setItemsId !== this.setItemsCurrentId) {
            // if the call that came back from getting urls is old we discard it here.
            return;
        }
        if (!setItemsId) {
            // new calls for preparing items will get a new progressing Id to give their follow-up calls after they get videoUrls.
            this.setItemsCurrentId++;
        }
        var _c = this.prepareItems(newItems), itemsToSet = _c.itemsToSet, shouldGetVideoUrls = _c.shouldGetVideoUrls;
        if (shouldGetVideoUrls) {
            this.buildVideoUrlsAndSet({
                newItems: newItems,
                setItemsId: this.setItemsCurrentId,
                currentItems: currentItems,
            });
        }
        this.setItems(currentItems.concat(itemsToSet));
    };
    ProGalleryStore.prototype.getItemsLoveDataIfNeeded = function (itemsListToGetLoveData) {
        var _this = this;
        var styleParams = this.styles;
        var loveButton = getProGalleryStyles(styleParams).loveButton;
        if (reactionServiceManager.shouldUseReactionService() &&
            loveButton &&
            itemsListToGetLoveData.length > 0) {
            var instance = this.context.instance;
            var baseUrl = Utils.getBaseUrl(this.wixCodeApi, this.viewMode);
            var galleryId = this.galleryId;
            var appDefinitionId = this.APP_DEFINITION_ID;
            reactionServiceManager
                .getItemsLoveData(itemsListToGetLoveData, instance, baseUrl, galleryId, appDefinitionId, this.sentryReport)
                .then(function (loveCountsReactionService) {
                // Accumalative object that stores all items' love data (from all batches)
                _this.fullListOfItemsLoveData = __assign(__assign({}, _this.fullListOfItemsLoveData), loveCountsReactionService);
                // Upate the 'component part' that new data love of items has arrived
                _this.setItemsLoveDataCallback(_this.fullListOfItemsLoveData);
            });
        }
    };
    ProGalleryStore.prototype.buildVideoUrlsAndSet = function (_a) {
        var _this = this;
        var newItems = _a.newItems, setItemsId = _a.setItemsId, currentItems = _a.currentItems;
        this.getItemsWithWixVideosUrls(newItems).then(function (itemsWithVideoUrls) {
            _this.prepareAndSetItems({
                newItems: itemsWithVideoUrls,
                setItemsId: setItemsId,
                currentItems: currentItems,
            });
        });
    };
    // async loadDimensionsAndSet(items, setWixCodeItemsCallback) {
    //   const itemsWithDimensions = await loadItemDimensions(items);
    //   this.prepareAndSetItems(itemsWithDimensions, setWixCodeItemsCallback);
    // }
    ProGalleryStore.prototype.setItems = function (items) {
        var _items = items.filter(function (item) { return !!item.mediaUrl || (item.metaData && !!item.metaData.html); });
        this.items = _items || this.items;
        this.itemsAreAvailableDeferred.resolve();
        this.triggerBlueprintCreation({ settingNewItems: true });
    };
    ProGalleryStore.prototype.setAllWixCodeItems = function (items) {
        var _items = items.filter(function (item) { return !!item.mediaUrl || (item.metaData && !!item.metaData.html); });
        this.allWixCodeItems = _items;
    };
    ProGalleryStore.prototype.getItems = function () {
        return this.items || [];
    };
    ProGalleryStore.prototype.getBlueprint = function () {
        return this.blueprint;
    };
    ProGalleryStore.prototype.setBlueprint = function (blueprint) {
        this.blueprint = blueprint;
        this.blueprintReadyDeferred.resolve();
        if (this.itemsSrc === 'wixCode') {
            this.wixCodeBlueprintDeferred.resolve(); // resolving that a wixCode items blueprint is available for flows that wait for it. namely art-store in albums
        }
    };
    ProGalleryStore.prototype.itemToGalleryItem = function (item) {
        var galleryItem = new GalleryItem({
            dto: item,
            watermark: undefined,
            resizeMediaUrl: resizeMediaUrl,
        });
        return galleryItem;
    };
    ProGalleryStore.prototype.constructMetaTagsItemData = function (galleryItem, page_url, fullscreen_url) {
        var itemData = {
            item: {
                id: galleryItem.id,
                type: galleryItem.type,
                title: galleryItem.title,
                description: galleryItem.description,
                page_url: page_url,
                fullscreen_url: fullscreen_url,
                image: {
                    url: galleryItem.createUrl(GALLERY_CONSTS.urlSizes.RESIZED, GALLERY_CONSTS.urlTypes.SEO),
                    width: galleryItem.width,
                    height: galleryItem.height,
                },
                video_url: galleryItem.videoUrl ||
                    galleryItem.createUrl(GALLERY_CONSTS.urlSizes.RESIZED, GALLERY_CONSTS.urlTypes.VIDEO),
                thumbnail: {
                    url: galleryItem.createUrl(GALLERY_CONSTS.urlSizes.RESIZED, GALLERY_CONSTS.urlTypes.LOW_RES),
                    width: 250,
                    height: 250,
                },
            },
        };
        return itemData;
    };
    ProGalleryStore.prototype.setMetaTagsInSSR = function (item, page_url, fullscreen_url, api) {
        var galleryItem = this.itemToGalleryItem(item);
        var itemData = this.constructMetaTagsItemData(galleryItem, page_url, fullscreen_url);
        this.setMetaTags(itemData, api);
    };
    ProGalleryStore.prototype.setMetaTags = function (itemData, api) {
        // Setting metaTags for SEO fullscreen navigation
        if (itemData.item) {
            api.seo.renderSEOTags({
                itemType: 'PRO_GALLERY_ITEM',
                itemData: itemData,
                asNewPage: true,
            });
        }
        else {
            api.seo.resetSEOTags();
        }
    };
    ProGalleryStore.prototype.setDirectFullscreenItem = function (item) {
        var _this = this;
        var _a = this.prepareItems([
            item,
        ]), itemsArray = _a.itemsToSet, shouldGetVideoUrls = _a.shouldGetVideoUrls;
        if (shouldGetVideoUrls) {
            this.getItemWithVideoUrls(item).then(function (itemWithVideoUrl) {
                _this.setDirectFullscreenItem(itemWithVideoUrl);
            });
        }
        var resItem = itemsArray[0];
        if (resItem.itemId && !resItem.metaData.isVideoPlaceholder) {
            this.directFullscreenItem = resItem;
            !this.setDirectfullscreenOnce && this.setDirectfullscreenItemCallBack();
            this.setDirectfullscreenOnce = true;
        }
    };
    ProGalleryStore.prototype.getDirectFullscreenItem = function () {
        return this.directFullscreenItem ? this.directFullscreenItem : false;
    };
    ProGalleryStore.prototype.getTestType = function () {
        var queryParams = this.getQueryParams();
        var pgTestType = queryParams && queryParams.pgTestType;
        if (pgTestType) {
            return pgTestType;
        }
        else {
            return null;
        }
    };
    ProGalleryStore.prototype.getSSRWorkerLog = function () {
        return this.SSRWorkerLog;
    };
    ProGalleryStore.prototype.addItems = function (items, from) {
        var curItems = this.getItems();
        this.prepareAndSetItems({
            newItems: items,
            currentItems: curItems.slice(0, from),
        });
    };
    ProGalleryStore.prototype.loadInitialItems = function (isSSR) {
        return __awaiter(this, void 0, void 0, function () {
            var itemsPromise;
            var _this = this;
            return __generator(this, function (_a) {
                if (utils.isVerbose()) {
                    console.log('Getting initial items from server', this.items, this.totalItemsCount);
                }
                if (this.items && this.items.length > 0) {
                    // items were already loaded by wix-code or warmup data
                    return [2 /*return*/, Promise.resolve(this.items)];
                }
                else {
                    itemsPromise = void 0;
                    if (this.avoidGettingItemsFromPGServer) {
                        itemsPromise = Promise.resolve({
                            pageResponse: {
                                totalItemsCount: 0,
                                items: [],
                            },
                        });
                    }
                    else {
                        try {
                            itemsPromise = this.getGalleryDataFromServer({
                                from: 0,
                                batchSize: this.INITIAL_ITEMS_BATCH_SIZE,
                                options: { isSSR: isSSR },
                            });
                        }
                        catch (e) {
                            console.error('couldnt get items', e);
                            itemsPromise = Promise.resolve({
                                pageResponse: {
                                    totalItemsCount: 0,
                                    items: [],
                                },
                            });
                        }
                    }
                    return [2 /*return*/, itemsPromise.then(function (response) {
                            if (utils.isVerbose()) {
                                console.log('Got initial items from server', response);
                            }
                            try {
                                var galleryId = response.galleryId, dateCreated = response.dateCreated;
                                var _a = response.pageResponse, items = _a.items, settings = _a.settings, totalItemsCount = _a.totalItemsCount;
                                if (_this.isArtStore) {
                                    // albums store additional setting and galleryId coming from wix code.
                                    if (!_this.galleryId) {
                                        // albums store galleryId coming from wix code
                                        _this.galleryId = galleryId;
                                    }
                                    // add the settings to existing settings
                                    _this.setSettings(settings);
                                    _this.dateCreated = dateCreated;
                                }
                                else {
                                    Object.assign(_this, { galleryId: galleryId, dateCreated: dateCreated, settings: settings }); // parse everything
                                }
                                if (_this.itemsSrc !== 'wixCode') {
                                    // do not override wixCode items with items from db
                                    _this.prepareAndSetItems({ newItems: items });
                                    _this.totalItemsCount = Number(totalItemsCount);
                                }
                            }
                            catch (e) {
                                console.error('Could not fetch initial items from server', e, response);
                                _this.totalItemsCount = 1;
                            }
                            return _this.getItems();
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    ProGalleryStore.prototype.getBlueprintFromServer = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        url = this.baseUrl + "/_serverless/pro-gallery-blueprints-server/createBlueprint";
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                credentials: 'omit',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(__assign({}, args)),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 3:
                        error_4 = _a.sent();
                        console.error('couldnt get blueprint from server ', error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.fetchParamsAndGetBlueprintFromServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all([this.getPGStyles()]).then(function (_a) {
                        var styles = _a[0];
                        return __awaiter(_this, void 0, void 0, function () {
                            var params, blueprint;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        params = {
                                            styles: styles,
                                            dimensions: this.getDimensions(),
                                        };
                                        return [4 /*yield*/, this.getBlueprintFromServer(params)];
                                    case 1:
                                        blueprint = _b.sent();
                                        if (utils.isVerbose()) {
                                            console.count('blueprint from server');
                                        }
                                        return [2 /*return*/, blueprint];
                                }
                            });
                        });
                    })];
            });
        });
    };
    ProGalleryStore.prototype.isServerBlueprintsForcedByQuery = function () {
        var blueprintsServerQuery = 'forceServerBlueprints';
        var query = this.wixCodeApi.location.query;
        return query && query[blueprintsServerQuery] === 'true';
    };
    ProGalleryStore.prototype.createInitialBlueprint = function (isSSR) {
        return __awaiter(this, void 0, void 0, function () {
            var previewUseServerBlueprints, siteUseServerBlueprints;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Utils.verifyExperiments(this.scopedGlobalSdkApis)];
                    case 1:
                        _a.sent(); // make sure experiments were requestd and are ready before proceeding
                        previewUseServerBlueprints = this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW &&
                            experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useServerBlueprints-preview');
                        siteUseServerBlueprints = this.viewMode !== GALLERY_CONSTS.viewMode.PREVIEW &&
                            experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useServerBlueprints-viewer');
                        this.shouldUseBlueprintsFromServer =
                            siteUseServerBlueprints ||
                                previewUseServerBlueprints ||
                                this.isServerBlueprintsForcedByQuery();
                        this.blueprintsManager = new BlueprintsManager({
                            id: "pgStore " + this.context.compId,
                        });
                        this.generateBlueprintsApi();
                        return [4 /*yield*/, this.loadInitialItems(isSSR)];
                    case 2:
                        _a.sent();
                        this.blueprintsManagerReadyDeferred.resolve(); // resolve this after the this.blueprintManager is ready to shoot following blueprints
                        return [2 /*return*/, Promise.all([
                                this.dimensionsAreAvailableDeferred.promise,
                                this.stylesAreAvailableDeferred.promise,
                                this.itemsAreAvailableDeferred.promise,
                                this.viewMode === GALLERY_CONSTS.viewMode.EDIT
                                    ? Promise.reject() // we dont want an initial blueprint in the editor. it will be created only after all the params get back from the component, namely the dimensions the user set.
                                    : Promise.resolve(),
                            ]).then(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.triggerBlueprintCreation(true);
                                    return [2 /*return*/];
                                });
                            }); }, function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {}];
                                });
                            }); })];
                }
            });
        });
    };
    ProGalleryStore.prototype.initFlowPromises = function () {
        var _this = this;
        this.blueprintReadyDeferred = new Deferred(); // to be resolved when a blueprint is available
        this.wixCodeBlueprintDeferred = new Deferred(); // to be resolved when wixCodeItems have a ready blueprint - for art-store in albums
        this.blueprintsManagerReadyDeferred = new Deferred(); // to be resolved when BM is ready (and onBlueprintReady is armed)
        this.dimensionsAreAvailableDeferred = new Deferred(); // to be resolved when simensions are available
        this.stylesAreAvailableDeferred = new Deferred(); // to be resolved when styles are available
        this.itemsAreAvailableDeferred = new Deferred(); // to be resolved when items are available
        this.readyToCreateBlueprintsDeferred = new Deferred(); // to be resolved when we can trigger blueprints
        Promise.all([
            this.dimensionsAreAvailableDeferred.promise,
            this.stylesAreAvailableDeferred.promise,
            this.itemsAreAvailableDeferred.promise,
            this.blueprintsManagerReadyDeferred.promise,
        ]).then(function () {
            _this.readyToCreateBlueprintsDeferred.resolve(); // this should be resolved after everything is ready to create more blueprints when triggerBlueprintCreation is fired.
        });
    };
    ProGalleryStore.prototype.setDimensions = function (dimensions) {
        this.dimensions = dimensions || this.dimensions;
        this.dimensionsAreAvailableDeferred.resolve();
    };
    ProGalleryStore.prototype.setIsAccessible = function (isAccessible) {
        this.isAccessible = isAccessible;
    };
    ProGalleryStore.prototype.addDimensionsToCache = function (itemDimensions) {
        var _this = this;
        itemDimensions.forEach(function (dimensions) {
            _this.itemDimensionsCache[dimensions.mediaUrl] = dimensions;
        });
    };
    ProGalleryStore.prototype.addDimensionsFromCache = function (item) {
        var dimensions = this.itemDimensionsCache[item.mediaUrl];
        if (dimensions) {
            return __assign(__assign({}, item), { metaData: __assign(__assign({}, item.metaData), { width: dimensions.width, height: dimensions.height }), measured: true });
        }
        return null;
    };
    ProGalleryStore.prototype.handleNewItemDimensions = function (itemDimensions) {
        var _this = this;
        this.addDimensionsToCache(itemDimensions);
        var curItems = this.getItems();
        var setDimensions = false;
        var itemsWithDimensions = curItems.map(function (item) {
            if (utils.isDimensionless(item)) {
                var itemWithDimensions = _this.addDimensionsFromCache(item);
                if (!!itemWithDimensions) {
                    item = itemWithDimensions;
                    setDimensions = true;
                }
            }
            return item;
        });
        if (setDimensions) {
            this.setItems(itemsWithDimensions);
            // Items with added dimensions were already "set" with all needed properties. this is true for server and wixCode items
        }
    };
    ProGalleryStore.prototype.getDimensions = function () {
        return this.dimensions;
    };
    ProGalleryStore.prototype.handleDimensions = function (dimensions) {
        this.setDimensions(dimensions);
        this.triggerBlueprintCreation({ settingNewItems: false });
    };
    ProGalleryStore.prototype.handleAccessibilityChange = function (isAccessible) {
        this.setIsAccessible(isAccessible);
        this.triggerBlueprintCreation({ settingNewItems: false });
    };
    ProGalleryStore.prototype.setStyles = function (styles) {
        this.styles = styles || this.styles;
        this.stylesAreAvailableDeferred.resolve();
    };
    ProGalleryStore.prototype.handleStylesChange = function (styles) {
        this.setStyles(styles);
        this.triggerBlueprintCreation({ settingNewItems: false });
    };
    ProGalleryStore.prototype.getMoreItems = function (from) {
        this.blueprintsManager.getMoreItems(from);
    };
    ProGalleryStore.prototype.getMoreItemsFromItemsSource = function (from) {
        return __awaiter(this, void 0, void 0, function () {
            var getMoreItems;
            var _this = this;
            return __generator(this, function (_a) {
                getMoreItems = this.itemsSrc === 'wixCode'
                    ? this.getMoreWixCodeItems
                    : this.getMoreItemsFromServer;
                return [2 /*return*/, getMoreItems(from).then(function (items) {
                        _this.addItems(items);
                    })];
            });
        });
    };
    ProGalleryStore.prototype.getMoreWixCodeItems = function (from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getItemsFromWixCode({
                        from: from,
                        batchSize: this.ITEMS_BATCH_SIZE,
                    })];
            });
        });
    };
    ProGalleryStore.prototype.getTotalItemsCount = function () {
        return this.totalItemsCount || 1337;
    };
    ProGalleryStore.prototype.createBlueprintImp = function (args) {
        if (this.shouldUseBlueprintsFromServer) {
            args.formFactor = this.formFactor;
            return this.getBlueprintFromServer(args);
        }
        else {
            return blueprints.createBlueprint(args);
        }
    };
    ProGalleryStore.prototype.setBlueprintIfNeeded = function (blueprint, blueprintChanged) {
        if (blueprintChanged === void 0) { blueprintChanged = true; }
        if (!blueprint) {
            return;
        }
        if (blueprintChanged) {
            this.setBlueprint(blueprint);
        }
        this.setBlueprintCallback();
    };
    ProGalleryStore.prototype.generateBlueprintsApi = function () {
        var _this = this;
        var functions = {
            createBlueprintImp: function (args) { return _this.createBlueprintImp(args); },
            getItems: function () { return _this.getItems(); },
            getMoreItems: function (from) {
                return _this.getMoreItemsFromItemsSource(from).then(function () {
                    return _this.getItems();
                });
            },
            getTotalItemsCount: function () { return _this.totalItemsCount; },
            getStyles: function () { return _this.getPGStyles(); },
            getContainer: function () { return _this.getDimensions(); },
            onBlueprintReady: this.setBlueprintIfNeeded,
        };
        var wrapperBlueprintsApi = new BlueprintsApi(functions);
        this.blueprintsManager.init({
            api: wrapperBlueprintsApi,
            formFactor: this.formFactor,
        });
    };
    ProGalleryStore.prototype.loadInitialBlueprint = function (isSSR) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Utils.verifyExperiments(this.scopedGlobalSdkApis)];
                    case 1:
                        _a.sent(); // make sure experiments were requestd and are ready before proceeding
                        if (utils.isVerbose()) {
                            console.log('Getting initial blueprint');
                        }
                        try {
                            this.createInitialBlueprint(isSSR);
                        }
                        catch (e) {
                            console.error('couldnt get blueprint', e);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProGalleryStore.prototype.loadInitialDataForArtStore = function (isSSR) {
        var itemsPromise;
        try {
            itemsPromise = this.getGalleryDataFromServer({
                from: 0,
                batchSize: this.INITIAL_ITEMS_BATCH_SIZE,
                options: { isSSR: isSSR },
            });
        }
        catch (e) {
            console.error('couldnt get items', e);
            itemsPromise = Promise.resolve({
                pageResponse: {
                    totalItemsCount: 0,
                    items: [],
                },
            });
        }
        return itemsPromise;
    };
    ProGalleryStore.prototype.loadDirectFullscreen = function (itemId, isSSR) {
        var _this = this;
        var directFullscreenItemPromise;
        if (this.isArtStore) {
            directFullscreenItemPromise = this.getItemByIdFromOldServer(itemId, isSSR);
        }
        else {
            directFullscreenItemPromise = this.getItemByIdFromNewServer(itemId, isSSR);
        }
        return directFullscreenItemPromise.then(function (item) {
            if (item && item.itemId) {
                _this.setDirectFullscreenItem(item);
            }
            else {
                if (utils.isVerbose()) {
                    console.log('Could not fetch direct fullscreen item from server', item, '' + _this.directFullscreenItem
                        ? 'The directFullscreen was loaded from wixCode'
                        : '');
                }
            }
            return _this.getDirectFullscreenItem();
        });
    };
    ProGalleryStore.prototype.pageReady = function (setProps) {
        this.setProps = setProps;
    };
    ProGalleryStore.prototype.handleManualStyleParams = function (manualStyleParams) {
        this.setManualStyleParams(manualStyleParams);
        this.triggerBlueprintCreation({ settingNewItems: false });
    };
    ProGalleryStore.prototype.triggerBlueprintCreation = function (_a) {
        var _this = this;
        var settingNewItems = _a.settingNewItems;
        this.readyToCreateBlueprintsDeferred.promise.then(function () {
            if (settingNewItems === true) {
                _this.blueprintsManager.resetItemLooping();
            }
            _this.blueprintsManager.createBlueprint();
        });
    };
    ProGalleryStore.prototype.setManualStyleParams = function (manualStyleParams) {
        this.manualStyleParams = manualStyleParams;
    };
    ProGalleryStore.prototype.getManualStyleParams = function () {
        return this.manualStyleParams || {};
    };
    ProGalleryStore.prototype.shouldDisableStoreExpandMode = function () {
        if (this.isArtStore && this.settings) {
            var _a = this.settings, freeArtStore = _a.freeArtStore, ignoreFullscreen = _a.ignoreFullscreen;
            return !!(freeArtStore && ignoreFullscreen);
        }
        else {
            return false;
        }
    };
    ProGalleryStore.prototype.isStoreGallery = function () {
        var _a;
        var freeArtStore = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.freeArtStore;
        return this.isArtStore && !freeArtStore;
    };
    ProGalleryStore.prototype.getPGStyles = function () {
        return __awaiter(this, void 0, void 0, function () {
            var styleParams, isMobile, isStoreGallery, pgStyles, fullscreenStyles, styles, fixRatio;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Utils.verifyExperiments(this.scopedGlobalSdkApis)];
                    case 1:
                        _a.sent(); // make sure experiments were requestd and are ready before proceeding
                        styleParams = this.styles;
                        isMobile = this.isMobile;
                        isStoreGallery = this.isStoreGallery();
                        if (this.shouldDisableStoreExpandMode()) {
                            // albums free store set itemClick nothing
                            styleParams.numbers.itemClick = 2;
                        }
                        pgStyles = getProGalleryStyles(styleParams, {
                            isMobile: isMobile,
                            isStoreGallery: isStoreGallery,
                        });
                        fullscreenStyles = __assign({}, parseStyleParams(styleParams, isStoreGallery, isMobile));
                        styles = __assign(__assign(__assign(__assign({}, fullscreenStyles), pgStyles), this.getManualStyleParams()), { isAccessible: this.isAccessible });
                        if (isMobile && !this.isSSR() && typeof styles.gallerySize === 'number') {
                            fixRatio = void 0;
                            if (this.viewMode === GALLERY_CONSTS.viewMode.PREVIEW) {
                                fixRatio = 320 / this.getDimensions().mobilePreviewFrame.width; // in preview, the mobile view is simualted in a "mobile device" with width of 320
                            }
                            else {
                                fixRatio = 320 / this.getDimensions().screen.width;
                            }
                            styles.gallerySize *= fixRatio;
                            styles.imageMargin *= fixRatio;
                        }
                        return [2 /*return*/, styles];
                }
            });
        });
    };
    return ProGalleryStore;
}());
export default ProGalleryStore;
//# sourceMappingURL=ProGalleryStore.js.map